import React, { useEffect, useRef, useState, useCallback } from 'react';
import * as echarts from 'echarts';
import { Dropdown, DropdownOption } from '@abb/abb-common-ux-react';
import "./peak-monitoring.css";
import peakMonitor from './peak-monitor-option.json';
import PeriodList from '../../Period-Dropdown-list/period-dropdown-list';
import axios from 'axios';
import { getToken } from "../../Authentication/get-token";
import { BASE_URL } from '../../../strings';
import "./peak-monitoring.css"
const PeakMonitoring = () => {
  const chartRef = useRef(null);
  const [assetValue, setAssetValue] = useState('');
  const [showContractual, setShowContractual] = useState(false);
  const [apiData, setApiData] = useState([]);

  const fetchPeakData = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}emapi/peak_monitoring`,getToken());
      setApiData(response.data.dataConfig || []);
    } catch (err) {
      console.error('Failed to fetch peak monitoring data:', err);
    }
  }, []);

  useEffect(() => {
    fetchPeakData();
  }, [fetchPeakData]);

  useEffect(() => {
    if (!chartRef.current || apiData.length === 0) return;

    const chart = echarts.init(chartRef.current);

    const option = {
      grid: {
        left: '5%',
        right: '2%',
        top: '15%',
        bottom: '20%',
        containLabel: true
      },
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'category',
        data: apiData.map(item => item.labels),
        axisLabel: {
          padding: peakMonitor.xAxis.axisLabel.padding,
          interval: 0,
          rotate: 45,
        },
        nameLocation: peakMonitor.xAxis.nameLocation,
        axisTick: {
          alignWithLabel: peakMonitor.xAxis.axisTick.alignWithLabel
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          padding: peakMonitor.yAxis.axisLabel.padding
        },
        name: peakMonitor.yAxis.name,
        nameLocation: peakMonitor.yAxis.nameLocation,
        nameRotate: peakMonitor.yAxis.nameRotate,
        nameGap: 30,
      },
      series: [
        {
          type: 'line',
          data: apiData.map(item => item.values),
          itemStyle: peakMonitor.series[0].itemStyle,
          name: showContractual ? 'ABB SACE BUILDING' : 'Active power',
        },
        ...(showContractual ? [{
          type: 'line',
          data: Array(apiData.length).fill(300),
          lineStyle: { color: 'orange' },
          name: 'Contractual power',
          symbol: 'line',
          symbolSize: 2,
        }] : [])
      ],
      legend: {
        data: showContractual
          ? [{ name: 'ABB SACE BUILDING' }, { name: 'Contractual power' }]
          : [{ name: 'Active power', icon: 'circle' }],
        y: '5%',
        x: '40%',
      },
      dataZoom: [{ type: 'inside' }],
      grid: {
        left: '5%',
        right: '5%',
        bottom: '20%',
        containLabel: true,
      },
      graphic: [{
        type: 'text',
        left: 'center',
        bottom: '16%',
        style: {
          text: 'Today (29 Jul 2025)', // You can make this dynamic if needed
          textAlign: 'center',
        },
      }],
    };

    chart.setOption(option);

    // Add resize listener for responsiveness
    const handleResize = () => {
      chart.resize();
    };

    // ResizeObserver for container size changes
    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });

    window.addEventListener('resize', handleResize);
    resizeObserver.observe(chartRef.current);

    // Initial resize to ensure proper sizing
    setTimeout(handleResize, 100);

    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [apiData, showContractual]);

  const handleCheckboxChange = (e) => {
    setShowContractual(e.target.checked);
  };

  return (
    <div className='peak-block'>
      <div className='peak-indicator-container-line'>
        <Dropdown
          label="Asset"
          placeholder="Select..."
          value={assetValue}
          onChange={setAssetValue}
        >
          {peakMonitor.dropdownOptions[0].options.map(option => (
            <DropdownOption key={option.key} label={option.label} value={option.value} />
          ))}
        </Dropdown>

        <PeriodList />

        <label className='peak-monitoring' style={{ display: 'flex', alignItems: 'center', marginTop: '38px' }}>
          <input
            type="checkbox"
            checked={showContractual}
            onChange={handleCheckboxChange}
            style={{ accentColor: 'royalblue' }}
            className='checkbox'
          />
          {peakMonitor.checkbox.label}
        </label>
      </div>

      <div className='peak-chart-container'>
        <div ref={chartRef} className='peak-chart' />
      </div>
    </div>
  );
};

export default PeakMonitoring;
